import type { AnyRouter } from '@tanstack/react-router';

let current: AnyRouter | null = null;

export const bindRouter = (router: AnyRouter): void => {
  current = router;
};

export const peekRouter = (): AnyRouter | null => current;

export const getRouter = (): AnyRouter => {
  if (!current) throw new Error('Router is not created yet');
  return current;
};
